export default __webpack_public_path__ + "static/media/stbernadette.cb7aacac.jpg";